// CustomReportModal.jsx
import React, { useState } from 'react';
import colors from '../../Utils/colors';
import images from '../../Utils/images';
import CheerioButton from '../CheerioButton';
import { Form } from 'react-bootstrap';
import { Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { downloadCustomReportAPI } from '../../Services';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ReplayIcon from '@mui/icons-material/Replay';

const CustomReportModal = ({ setShowCustomReport }) => {
    const authtoken = useSelector((state) => state.main.auth_token);
    const [isDownloading, setIsDownloading] = useState(false);
    const [filters, setFilters] = useState({
        day: {
            startDate: dayjs().subtract(30, 'day'),
            endDate: dayjs(),
        },
    });

    const clearFilters = () => {
        setFilters({
            day: {
                startDate: null,
                endDate: null,
            },
        });
    };

    const validateDateRange = () => {
        const { startDate, endDate } = filters.day;

        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates.', { position: 'top-center' });
            return false;
        }

        const daysDifference = dayjs(endDate).diff(dayjs(startDate), 'day');

        if (daysDifference > 30) {
            toast.error('Date range cannot exceed 30 days.', { position: 'top-center' });
            return false;
        }

        if (daysDifference < 0) {
            toast.error('End date must be after start date.', { position: 'top-center' });
            return false;
        }

        return true;
    };

    const downloadCustomReport = async () => {
        if (!validateDateRange()) return;

        const { startDate, endDate } = filters.day;

        try {
            setIsDownloading(true);

            const response = await downloadCustomReportAPI(
                authtoken,
                dayjs(startDate).format("YYYY-MM-DDTHH:mm:ssZ"),
                dayjs(endDate).format("YYYY-MM-DDTHH:mm:ssZ")

            );

            // Create blob and trigger download
            const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "custom_report.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.success("Report downloaded successfully!", { position: "top-center" });

            setTimeout(() => {
                setShowCustomReport(false);
            }, 1000);

        } catch (error) {
            console.error("Error downloading custom report:", error);
            toast.error("Failed to download report. Please try again.", { position: "top-center" });
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div className="DarkBg" onClick={() => { }}>
            <div className="Center">
                <div
                    style={{
                        width: 500,
                        height: '32vh',
                        backgroundColor: colors.white01,
                        borderRadius: 16,
                        zIndex: 0,
                        border: `1px solid ${colors.borderwhite}`,
                        padding: 16,
                        overflowY: 'scroll',
                    }}
                >
                    <div className="d-flex flex-column justify-content-between align-items-center w-100 h-100">
                        <div
                            className="d-flex flex-row justify-content-between align-items-center w-100"
                            style={{ marginTop: '-6px' }}
                        >
                            <h2
                                style={{
                                    fontSize: 20,
                                    fontWeight: 700,
                                    color: colors.black,
                                }}
                            >
                                Download Custom Report
                            </h2>
                            <img
                                src={images.CMClose}
                                style={{
                                    height: 32,
                                    width: 32,
                                    objectFit: 'contain',
                                    cursor: 'pointer',
                                    paddingRight: '4px',
                                    marginRight: '-16px',
                                }}
                                onClick={() => setShowCustomReport(false)}
                            />
                        </div>
                        <hr style={{ width: '100%', marginTop: '-14px' }} />
                        <p
                            style={{
                                fontSize: 16,
                                fontWeight: 400,
                                color: '#666666',
                                width: '100%',
                                marginTop: '-22px',
                            }}
                        >
                            Select a date range (maximum 30 days) to download your custom report.
                        </p>
                        <div
                            className="d-flex align-items-center justify-content-between"
                            style={{
                                marginBottom: '12px',
                                marginTop: '0px',
                                width: '100%',
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div style={{ flex: 1, marginRight: 10, cursor: 'pointer' }}>
                                    <DatePicker
                                        value={filters.day.startDate}
                                        onChange={(newValue) =>
                                            setFilters((prev) => ({
                                                ...prev,
                                                day: { ...prev.day, startDate: newValue },
                                            }))
                                        }
                                        disableFuture
                                        label="Start Date"
                                        maxDate={filters.day.endDate ? dayjs(filters.day.endDate) : undefined}
                                        renderInput={(params) => (
                                            <Form.Control {...params} style={{ borderRadius: 8 }} />
                                        )}
                                    />
                                </div>

                                <div style={{ marginLeft: '1px', marginRight: '10px' }}>-</div>

                                <div style={{ flex: 1, position: 'relative', cursor: 'pointer' }}>
                                    <DatePicker
                                        value={filters.day.endDate}
                                        minDate={filters.day.startDate || null}
                                        maxDate={
                                            filters.day.startDate
                                                ? dayjs(filters.day.startDate).add(30, 'day')
                                                : undefined
                                        }
                                        onChange={(newValue) =>
                                            setFilters((prev) => ({
                                                ...prev,
                                                day: { ...prev.day, endDate: newValue },
                                            }))
                                        }
                                        disableFuture
                                        label="End Date"
                                        renderInput={(params) => (
                                            <Form.Control {...params} style={{ borderRadius: 8 }} />
                                        )}
                                    />
                                </div>
                            </LocalizationProvider>

                            <Tooltip title="Reset Filter">
                                <ReplayIcon
                                    style={{
                                        fontSize: 28,
                                        color: colors.black,
                                        cursor: 'pointer',
                                        marginLeft: 10,
                                        marginTop: '-12px',
                                        marginRight: '-16px',
                                    }}
                                    onClick={clearFilters}
                                />
                            </Tooltip>
                        </div>

                        <CheerioButton
                            borderStyle={{
                                borderWidth: 0,
                                borderRadius: 12,
                                paddingInline: 32,
                                width: '100%',
                            }}
                            backColor={'#8E53F7'}
                            textStyle={{ fontSize: 14, color: colors.white01 }}
                            btnText={isDownloading ? 'Downloading...' : 'Download Report'}
                            onclick={downloadCustomReport}
                            disabled={isDownloading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomReportModal;